import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["price", "promo", "preview"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasPreviewTarget) return

    const price = this.priceTarget.value.trim()
    const promo = this.promoTarget.value.trim()
    if (!promo || !price) {
      this.previewTarget.classList.add("hidden")
      this.previewTarget.textContent = ""
      return
    }

    this.previewTarget.classList.remove("hidden")
    this.previewTarget.innerHTML = `<span class="line-through text-(--muted)">${this.escape(price)}</span> <span class="t-strong">${this.escape(promo)}</span>`
  }

  escape(value) {
    const el = document.createElement("span")
    el.textContent = value
    return el.innerHTML
  }
}
